module.exports = __webpack_public_path__ + "static/img/sebastian_pictgrid43_960x872.cc1f75c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/sebastian_pictgrid43_960x872.jpg
// module id = bPLC
// module chunks = 0